module.exports = __webpack_public_path__ + "img/clockwise-rotation.be2f0ad9.svg";